type ProductRecs = {
  [key: string]: string[];
};

export const VIDEO_RECOMMENDATIONS: ProductRecs = {
  MD: [
    'Anatomy of the Coronary circulation',
    'Renin-angiotensin aldosterone system',
  ],
  PA: [
    'Anatomy of the Coronary circulation',
    'Renin-angiotensin-aldosterone system',
  ],
  DO: [
    'Anatomy of the knee joint',
    'Sliding filament model of muscle contraction',
  ],
  NP: ['Diabetes mellitus', 'Insulins'],
  DN: ['Anatomy and physiology of the teeth', 'Gingivitis and periodontitis'],
  OH: [
    'Anatomy of the knee joint',
    'Sliding filament model of muscle contraction',
  ],
  RN: ['ADPIE: Bacterial pneumonia', 'ADPIE: Pyloric stenosis'],
  PH: [
    'Lipid-lowering medications: Statins',
    'Pharmacodynamics: Drug-receptor interactions',
  ],
};
